<template>
  <div>

    <fieldset>
      <legend class="visually-hidden">{{ $t('common.formsSubTitle.gnrl') }}</legend>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)" 
           :aria-expanded="isGeneralSectionExpanded ? 'true' : 'false'"
           :aria-controls="'general-section'"
           role="button">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.gnrl') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content" id="general-section" role="region" :aria-labelledby="'general-heading'">
          <div class="form-group d-flex justify-content-between">
            <label for="checkbox-pain001" class="col-form-label">{{ $t('settings.gnrt_bnk_trnsfr_ordr') }}</label>
            <div class="label-switch " :class="sliderColorClass">
              <input id="checkbox-pain001" type="checkbox" class="checkboxPain001" @change="switchPain001" :disabled="canSwichPain001()" :checked="settings.pain001 === '1'" v-bind:value="settings.pain001" :aria-describedby="canSwichPain001() ? 'pain001-disabled-info' : null">
              <div class="checkbox"></div>
            </div>
            <div v-if="canSwichPain001()" id="pain001-disabled-info" class="visually-hidden">{{ $t('accessibility.field_disabled_no_permission') }}</div>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label for="checkbox-pacs008" class="col-form-label labelCheckbox">{{ $t('settings.gnrt_instnt_pymnt') }}</label>
            <div class="label-switch " :class="sliderColorClass">
              <input id="checkbox-pacs008" type="checkbox" class="checkboxPacs008" @change="changeSwitchPacs008" :disabled="canSwitchPacs008()" :checked="settings.pacs008 === '1'" v-bind:value="settings.pacs008" :aria-describedby="canSwitchPacs008() ? 'pacs008-disabled-info' : null">
              <div class="checkbox"></div>
            </div>
            <div v-if="canSwitchPacs008()" id="pacs008-disabled-info" class="visually-hidden">{{ $t('accessibility.field_disabled_no_permission') }}</div>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label for="checkbox-decision-creancier" class="col-form-label">{{ $t('directPayments.dir_pymnt_decision_form') }}</label>
            <div class="label-switch " :class="sliderColorClass">
              <input id="checkbox-decision-creancier" type="checkbox" class="checkboxDecisionCreancier" @change="changeSwitchDecisionCreancier" :disabled="canSwitchCreditorDecision()" :checked="settings.decision_creancier === '1'" v-bind:value="settings.decision_creancier" :aria-describedby="canSwitchCreditorDecision() ? 'decision-disabled-info' : null">
              <div class="checkbox"></div>
            </div>
            <div v-if="canSwitchCreditorDecision()" id="decision-disabled-info" class="visually-hidden">{{ $t('accessibility.field_disabled_no_permission') }}</div>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label for="checkbox-ocr-activation" class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
            <div class="label-switch" :class="sliderColorClass">
              <input id="checkbox-ocr-activation" type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" :disabled="canSwitchOcrActivation()" :checked="settings.ocrActivation === '1'" v-bind:value="settings.ocrActivation" :aria-describedby="canSwitchOcrActivation() ? 'ocr-disabled-info' : null">
              <div class="checkbox"></div>
            </div>
            <div v-if="canSwitchOcrActivation()" id="ocr-disabled-info" class="visually-hidden">{{ $t('accessibility.field_disabled_no_permission') }}</div>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label for="checkbox-email-rcv" class="col-form-label">{{ $t('settings.ntfy_rcvr_by_eml') }}</label>
            <div class="label-switch " :class="sliderColorClass">
              <input id="checkbox-email-rcv" type="checkbox" class="checkboxEmailRcv" @change="switchEmailRcv" :disabled="canSwitchEmailRcv()" :checked="settings.emailForRcv === '1'" v-bind:value="settings.emailForRcv" :aria-describedby="canSwitchEmailRcv() ? 'email-disabled-info' : null">
              <div class="checkbox"></div>
            </div>
            <div v-if="canSwitchEmailRcv()" id="email-disabled-info" class="visually-hidden">{{ $t('accessibility.field_disabled_no_permission') }}</div>
          </div>
        </div>
      </div>
    </fieldset>

    <hr>

    <fieldset>
      <legend class="visually-hidden">{{ $t('common.formsSubTitle.othr') }}</legend>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)"
           :aria-expanded="isOtherSectionExpanded ? 'true' : 'false'"
           :aria-controls="'other-section'"
           role="button">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.othr') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content" id="other-section" role="region" :aria-labelledby="'other-heading'">
          <div class="form-group d-flex justify-content-between">
            <label for="checkbox-auto-accept" class="col-form-label">{{ $t('settings.allwys_accpt_dir_pymnts') }}</label>
            <div class="label-switch " :class="sliderColorClass">
              <input id="checkbox-auto-accept" type="checkbox" class="checkboxAutoAcceptPayment" @change="changeSwitchAutoAcceptPayment" :disabled="canSwitchAutoAcceptPayment()" :checked="settings.auto_accept_payment === '1'" v-bind:value="settings.auto_accept_payment" :aria-describedby="canSwitchAutoAcceptPayment() ? 'auto-accept-disabled-info' : null">
              <div class="checkbox"></div>
            </div>
            <div v-if="canSwitchAutoAcceptPayment()" id="auto-accept-disabled-info" class="visually-hidden">{{ $t('accessibility.field_disabled_no_permission') }}</div>
          </div>
          <div class="form-group">
            <label for="range-max-amount" class="col-form-label">{{ $t('settings.hghst_amnt') }}</label>
            <div class="" style="text-align: right;" aria-live="polite">{{ settings.max_amount }}</div>
            <input id="range-max-amount" class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="150000" value="0" step="500" :disabled="canSwitchMaxAmount()" v-model="settings.max_amount" :aria-describedby="canSwitchMaxAmount() ? 'max-amount-disabled-info' : 'max-amount-value'" aria-label="Montant maximum en euros">
            <div v-if="canSwitchMaxAmount()" id="max-amount-disabled-info" class="visually-hidden">{{ $t('accessibility.field_disabled_no_permission') }}</div>
            <div id="max-amount-value" class="visually-hidden">{{ $t('accessibility.current_amount') }}: {{ settings.max_amount }} euros</div>
          </div>
        </div>
      </div>
    </fieldset>
    <b-row class="form-group justify-content-end mr-5">
      <b-col sm="3">
        <b-button variant="primary" size="lg"
          @click="changeApplicationSettings">
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ['settings'],
  data () {
    return {
      colorBottomButton: this.$engine.firstOn().services.getButtonClassColorById(this.$engine.firstOn().user.currentService.id),
      isGeneralSectionExpanded: true,
      isOtherSectionExpanded: true
    }
  },
  created () {
  },
  mounted () {
    // expand all menus
    let that = this
    this.Dom7('.accordion-item').addClass('accordion-item-expanded').forEach(item => {
      that.Dom7(item).addClass('accordion-item-expanded')
    })
    this.Dom7('.createInvoiceBand').forEach(item => {
      that.Dom7(item).find('i').transform('rotate(90deg)')
    })
  },
  computed: {
    sliderColorClass () {
      // let fromIdServiceToSliderClass = {
        // '1': 'RTP-slider',
        // '2': 'DD-slider',
        // '6': 'DP-slider'
      // }
      // return fromIdServiceToSliderClass[this.$engine.firstOn().user.currentService.id]
      return 'RTP-slider'
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    canSwichPain001 () {
      return this.$engine.firstOn().rights.rightIs('dp_settings_unit_generate_pain', false)
    },
    switchPain001 (obj) {
      this.settings.pain001 = obj.target.checked ? '1' : '0'
      if (this.settings.pain001 === '1') {
        this.Dom7('.checkboxPacs008').prop('disabled', false)
        this.Dom7('.labelCheckbox').removeClass('disablecolor')
        this.Dom7('.li_pacs008').show()
      } else {
        this.settings.pacs008 = '0'
        this.Dom7('.checkboxPacs008').prop('checked', false)
        this.Dom7('.checkboxPacs008').prop('disabled', true)
        this.Dom7('.labelCheckbox').addClass('disablecolor')
        this.Dom7('.li_pacs008').hide()
      }
    },
    canSwitchPacs008 () {
      return this.$engine.firstOn().rights.rightIs('dp_settings_unit_generate_pain_inst', false)
    },
    // checkboxPacs008 change event
    changeSwitchPacs008 (obj) {
      this.settings.pacs008 = obj.target.checked ? '1' : '0'
    },
    canSwitchEmailRcv () {
      return this.$engine.firstOn().rights.rightIs('dp_settings_unit_email_receiver', false)
    },
    // checkboxEmailRcv change event
    switchEmailRcv (obj) {
      this.settings.emailForRcv = obj.target.checked ? '1' : '0'
    },
    canSwitchCreditorDecision () {
      return this.$engine.firstOn().rights.rightIs('dp_settings_unit_decision_creancier', false)
    },
    // checkboxDecisionCreancier change event
    changeSwitchDecisionCreancier (obj) {
      this.settings.decision_creancier = obj.target.checked ? '1' : '0'
    },
    canSwitchOcrActivation () {
      return this.$engine.firstOn().rights.rightIs('dp_settings_unit_ocr_activation', false)
    },
    changeSwitchOcrActivation (obj) {
      this.settings.ocrActivation = obj.target.checked ? '1' : '0'
    },
    canSwitchAutoAcceptPayment () {
      return this.$engine.firstOn().rights.rightIs('dp_settings_unit_auto_accept', false)
    },
    // checkboxAutoAcceptPayment change event
    changeSwitchAutoAcceptPayment (obj) {
      this.settings.auto_accept_payment = obj.target.checked ? '1' : '0'
    },
    canSwitchMaxAmount () {
      return this.$engine.firstOn().rights.rightIs('dp_settings_unit_validation_threshold', false)
    },
    changeApplicationSettings () {
      let that = this
      this.paymentsMethod = that.Dom7('input[name=methodRadio]:checked').val()

      this.$engine.firstOn().settings.directPayments.update({
        pacs008: that.pacs008 === true ? '1' : '0',
        decision_creancier: that.decision_creancier === true ? '1' : '0',
        max_amount: that.max_amount,
        auto_accept_payment: that.auto_accept_payment === true ? '1' : '0',
        pain001: that.pain001 === true ? '1' : '0',
        emailForRcv: that.emailForRcv === true ? '1' : '0',
        ocrActivation: that.ocrActivation === true ? '1' : '0'
      })
      .then(() => {
        that.$f7.modal({
          title: 'Application settings modified',
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          that.idSettingsApplication = ''
          that.pacs008 = false
          that.decision_creancier = false
          // that.max_amount = 0
          that.auto_accept_payment = false
          that.pain001 = false
          that.emailForRcv = false
          that.ocrActivation = false
          // loadPage(that, {url: '/settings/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        errorMessageAlert(err, this)
      })
    }
  }
}
</script>
<style>
.styleGeneral:hover {
  text-decoration: underline;
  text-decoration-color: #51a45c;
}

/* Accessibilité RGAA - classe visually-hidden pour les légendes */
.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* Amélioration des contrôles de formulaire pour l'accessibilité */
fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
  margin-bottom: 0.5rem;
}

/* Focus amélioré pour les boutons d'accordéon */
.item-link[role="button"]:focus {
  outline: 3px solid #0066cc;
  outline-offset: 2px;
}

/* Meilleure visibilité des zones d'accordéon */
.accordion-item-content[role="region"] {
  border-left: 3px solid transparent;
}

.accordion-item-expanded .accordion-item-content[role="region"] {
  border-left-color: #0066cc;
}
</style>
